module.exports = __webpack_public_path__ + "8831b6b9f9146e82781d5ce352920d32.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/feather/feather.woff
 ** module id = ./src/styles/fonts/feather/feather.woff
 ** module chunks = 0
 **/